// extracted by mini-css-extract-plugin
export default {"modal-overlay":"ImageModal_modal-overlay__DHYwn","modal-content":"ImageModal_modal-content__NqhlG"};